module.exports = __webpack_public_path__ + "4545a912099fcb738a7954227503c950.png";